import React, { useCallback, useState } from 'react'

import { ModalAPI } from '../StoryShareModel'
import { CompleteModal } from '../CompleteModal'
import { useShareStoryToRoMutation } from './shareStoryToRO.types'
import { useZonesList } from '../../../../modulesCommon/serviceHooks'
import { useGetStoryLazyQuery } from '../../graphql/getStory.types'
import { useQuery } from '@apollo/client'
import { IProject } from '../../../../shared/interfaces'
import { GET_PROJECT } from '../../../../modulesCommon/graphql/queries'
import { TStory } from '../../types'

type UseShareStory = [
  React.ReactNode,
  () => void,
]

export const useShareStoryToRO = (story: TStory, handleModal?: (api: ModalAPI) => () => void): UseShareStory => {

  const { getZoneById } = useZonesList()
  const [getStory] = useGetStoryLazyQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      id: story.id
    }
  })
  const [shareMutation] = useShareStoryToRoMutation({
    onCompleted: () => getStory()
  })
  const [isOpen, setModalStatus] = useState<boolean>(false)
  const { data: projectData } = useQuery<
    { getCampaign: IProject }, { id: string }
  >(GET_PROJECT, {
    variables: {
      id: story?.campaign?.id ?? ''
    }
  })
  const originalProjectZone = getZoneById(projectData?.getCampaign.original_campaign.label_id)?.name ?? ''

  const handleShare = useCallback(
    (message: string) => shareMutation({
      variables: {
        input: {
          argument_id: parseInt(story.id),
          message
        }
      }
    }).then(() => {
      setModalStatus(true)
    }),
    [shareMutation, story.id]
  )

  const handleAction = useCallback(
    () => {
      if (typeof handleModal === 'function') {
        const openModal = handleModal({
          title: `Share your story with ${originalProjectZone} in the Global Hub`,
          description: (<p>Please confirm whether you would like to share this story with the repertoire owner.</p>),
          onShare: handleShare
        })
        openModal()
      }
    },
    [handleModal, handleShare, originalProjectZone]
  )

  return [
    (
      <CompleteModal
        key="complete-modal"
        title="Great work!"
        description={'Your story was shared with "repertoire owner" and will be viewable in the Global Hub on this project\'s Success Story tab.'}
        isOpen={isOpen}
        onClose={() => setModalStatus(false)}
      />
    ),
    handleAction
  ]
}
